import { useEffect, useState, type AnchorHTMLAttributes, type MouseEvent } from "react";

export function usePathname(): string {
  const [path, setPath] = useState(() => window.location.pathname);
  useEffect(() => {
    const update = () => setPath(window.location.pathname);
    window.addEventListener("popstate", update);
    window.addEventListener("bubblefun:navigate", update);
    return () => {
      window.removeEventListener("popstate", update);
      window.removeEventListener("bubblefun:navigate", update);
    };
  }, []);
  return path;
}

export function navigate(to: string): void {
  if (window.location.pathname === to) return;
  window.history.pushState({}, "", to);
  window.scrollTo({ top: 0, behavior: "instant" });
  window.dispatchEvent(new Event("bubblefun:navigate"));
}

export function Link({ href = "/", onClick, ...props }: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (
      event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
      || !href.startsWith("/")
    ) return;
    event.preventDefault();
    navigate(href);
  };
  return <a href={href} onClick={handleClick} {...props} />;
}
